import { createApiSlice } from "@common";
import {
  CRUD_CONTACT_PRIVACY_CONSENT
} from "@routes";

const apiConfig = [
  {
    name: "addContactPrivacyConsent",
    method: "post",
    url: CRUD_CONTACT_PRIVACY_CONSENT,
    stateKey: "message",
  },
  {
    name: "updateContactPrivacyConsent",
    method: "put",
    url: CRUD_CONTACT_PRIVACY_CONSENT,
    stateKey: "message",
  },
  {
    name: "deleteContactPrivacyConsent",
    method: "delete",
    url: CRUD_CONTACT_PRIVACY_CONSENT,
    stateKey: "message",
  },
  {
    name: "getContactPrivacyConsentByContactId",
    method: "get",
    url: CRUD_CONTACT_PRIVACY_CONSENT,
    stateKey: "data",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contactPrivacyConsent",
  apiConfig,
  customReducers
);

const contactPrivacyConsentSlice = slice;

export default contactPrivacyConsentSlice.reducer;

export const {
  addContactPrivacyConsent,
  updateContactPrivacyConsent,
  deleteContactPrivacyConsent,
  getContactPrivacyConsentByContactId,
} = thunks;

export const { rowSelect, setAdditionalData } = actions;
